import { useEffect, useState } from "react";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import {
  getNetworkStatus,
  subscribeNetworkStatus,
} from "@/lib/native/capacitorBridge";

export function useNetworkStatus() {
  const { isNative } = useNativePlatform();
  const [isOnline, setIsOnline] = useState(true);
  const [checked, setChecked] = useState(!isNative);

  useEffect(() => {
    let mounted = true;
    void getNetworkStatus().then((connected) => {
      if (mounted) {
        setIsOnline(connected);
        setChecked(true);
      }
    });
    const unsubscribe = subscribeNetworkStatus((connected) => {
      if (mounted) setIsOnline(connected);
    });
    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  return { isOnline, checked, showOfflineBanner: checked && !isOnline };
}
